import 'arrive';
import Swiper from 'swiper/bundle';

document.arrive('.block-page-slider', { existing: true }, function (el) {
  const container = el.querySelector('.block-page-slider__grid.swiper');
  if (!container || container.dataset.swiperInitialized === 'true') return;

  // Mark as initialized to avoid duplicates
  container.dataset.swiperInitialized = 'true';

  const slidesCount = container.querySelectorAll('.swiper-slide').length;

  function clamp(min, val, max) {
        return Math.min(Math.max(val, min), max);
    }

    function getSwiperGap() {
        return clamp(20, window.innerWidth * 0.0167, 32); 
    }


  // On mobile, turn grid into slider with 1.2 slides per view and no effect
  const swiper = new Swiper(container, {
    slidesPerView: 1.2,
    spaceBetween: getSwiperGap(),
    loop: false,
    freeMode: true,
    allowTouchMove: true, 
    breakpoints: {
        1560: {
            slidesPerView: slidesCount > 3 ? 3.5 : 3,
        },
        1440: {
            slidesPerView: 2.5,
        },
        600: {
            slidesPerView: 2.2,
        },
        550: {
            slidesPerView: 1.2,
        },
    },
  });

  // aggiorna il gap al resize
    window.addEventListener('resize', () => {
        swiper.params.spaceBetween = getSwiperGap();
        swiper.update();
    });
});